(() => {
  if (customElements.get('regios-price')) return;

  const connectedPrices = new Set();
  const updatePrices = () => connectedPrices.forEach(price => price.update());

  class RegiosPrice extends HTMLElement {
    #product;
    #fallbackTimer;

    connectedCallback() {
      try {
        this.#product = JSON.parse(this.dataset.product);
      } catch (error) {
        console.warn('[Regios prices] Invalid product data.', error);
        return;
      }

      connectedPrices.add(this);

      if (window.RegiosDOPP && !window.RegiosDOPP.api?.v0) {
        this.setAttribute('aria-busy', 'true');
        this.#fallbackTimer = setTimeout(() => this.reveal(), 5000);
      }

      queueMicrotask(() => this.update());
    }

    disconnectedCallback() {
      connectedPrices.delete(this);
      this.reveal();
    }

    reveal() {
      clearTimeout(this.#fallbackTimer);
      this.removeAttribute('aria-busy');
    }

    async update() {
      const api = window.RegiosDOPP?.api?.v0;
      const priceList = this.querySelector('price-list');

      if (!this.isConnected || !this.#product || !priceList || !api?.themeInterop?.updateOnPagePrices) return;

      try {
        if (this.hasAttribute('data-component-price')) {
          priceList.classList.remove('regios-dopp-generic-skip');
        }

        await api.themeInterop.updateOnPagePrices(this, this.closest('product-card') ? 'COLLECTION_PAGE' : 'PRODUCT_PAGE', this.#product);
      } catch (error) {
        console.warn('[Regios prices] Unable to update prices.', error);
        this.reveal();
      }
    }

    onPriceUpdated(detail) {
      if (Number(detail.priceUpdateArgs?.product?.productId) !== this.#product?.productId) return;

      if (this.hasAttribute('data-component-price')) {
        detail.priceContainer.classList.add('regios-dopp-generic-skip');
      }

      this.reveal();
    }
  }

  window.addEventListener('regios-dopp:api-initialized', updatePrices);
  window.addEventListener('regios-dopp:applied-code-configs-revalidated', updatePrices);
  window.addEventListener('regios-dopp:api-initialization-failed', () => connectedPrices.forEach(price => price.reveal()));
  window.addEventListener('regios-dopp:price-update', event => {
    const price = event.detail?.priceContainer?.closest('regios-price');
    if (price instanceof RegiosPrice) price.onPriceUpdated(event.detail);
  });

  customElements.define('regios-price', RegiosPrice);
})();
